import { ROOT } from "@thi.ng/logger/root";
const LOGGER = ROOT.childLogger("rstream");
export {
  LOGGER
};
